import { useState, useCallback, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import {t} from '@lingui/core/macro';

export const useCopyToClipboard = () => {
    const [isCopied, setIsCopied] = useState(false);
    const timerRef = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => () => clearTimeout(timerRef.current), []);

    const copy = useCallback(async(text: string) => {
        if (!text) {
            toast.info(t`Нет контента для копирования`);
            return false;
        }

        try {
            if (!navigator.clipboard) {
                toast.info(t`Ваш браузер не поддерживает Clipboard API`);
                return false;
            }

            await navigator.clipboard.writeText(text);
            setIsCopied(true);

            toast.info(t`Скопировано в буфер обмена`);

            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                setIsCopied(false);
            }, 2000);

            return true;
        } catch (error) {
            toast.info(t`Не удалось скопировать`);
            return false;
        }
    }, []);

    return {
        copy,
        isCopied,
    };
};